import { createApp } from "vue";
import App from "./App.vue";
import quasarUserOptions from "../quasar-user-options";
import {
  Quasar,
  QBtn,
  QSelect,
  QInput,
  QSpinnerAudio,
  QIcon,
  QDate,
  QPopupProxy,
  ClosePopup,
  QSpinner,
  QForm,
  QCard,
  QCardSection,
  QImg,
  QTd,
  QTable,
  QFile,
  QCheckbox,
  QCardActions,
  QDialog,
  QOptionGroup,
  QBadge,
} from "quasar";
import router from "./router/index.js";
import VueGtag from "vue-gtag";

createApp(App)
  .use(router)
  .use(VueGtag, {
    // gtag.js + initial config laddas redan av index.html (där Consent Mode
    // default=denied också är inställt). bootstrap: false hindrar vue-gtag
    // från att dubbel-injicera scriptet eller köra config igen — vi får
    // bara $gtag-helpern för custom events (typ favorit-klick).
    //
    // SPA route-tracking görs istället via router.afterEach nedan — gör
    // det mer transparent och separerar consent-state från page-tracking.
    bootstrap: false,
    config: { id: "G-W4SH1ZH8QD" },
    appName: "LiveGBG",
  })
  .use(Quasar, {
    ...quasarUserOptions,
    directives: {
      ClosePopup,
    },
    components: {
      QBtn,
      QSelect,
      QInput,
      QSpinnerAudio,
      QIcon,
      QDate,
      QPopupProxy,
      ClosePopup,
      QSpinner,
      QForm,
      QCardSection,
      QCard,
      QImg,
      QTd,
      QTable,
      QFile,
      QCheckbox,
      QCardActions,
      QDialog,
      QOptionGroup,
      QBadge,
    }, // Lägg till fler komponenter vid behov
  })
  .mount("#app");
